import type { ConfluencePageContributor } from '../../../../api/useTwgSources/gql/types';

export const deduplicateContributors = (
	contributors: ConfluencePageContributor[],
): ConfluencePageContributor[] => {
	if (contributors.length === 0) {
		return [];
	}

	const seen = new Set<string>();
	const uniqueContributors: ConfluencePageContributor[] = [];

	for (const contributor of contributors) {
		if (!seen.has(contributor.id)) {
			uniqueContributors.push(contributor);
			seen.add(contributor.id);
		}
	}

	return uniqueContributors;
};
